$(function(){
  showModalOnLoad();
  schoolAccModal();
  showEditInModal(); 
  showPlayersLicencesModal();
  showPlayersVersionsModal();
  
  showModalByName('modal-divisionDetail');
  // General function for all different modals
  showModalsByName();

  //General function for all different collapses
  showCollapsesByName();

  showPlayersUpdatesModal()
  showCreateInvoiceModal();
  setupOnExitModal();
  showElasticStatusModal();

  setupAddIndividualBillingInfoModal();

  setupDivisionPlayerActionModal();

  if($('#playerNotificationPopup').length) {
    setupPlayerNotificationModal();
  }


  var modal = $('.modal.showOnPageLoad');
  if (modal.length > 0) {      // this way otherwise in adjustable round, modal() is not a function
    modal.modal();
  }
})


let setupDivisionPlayerActionModal = () => {

    $('a.openDivisionPlayerActionModal').on('click', (e) => onClick(e));

    let onClick = (e) => {

        e.preventDefault();

        let linkElement = $(e.currentTarget);
        let modal = $(linkElement.attr('data-target'));
        
        let playerName = getPlayerName(linkElement);


        $('.modal-player-name', modal).text(linkElement.attr('data-playerName'));
        $('input[name=playerId]', modal).val(linkElement.attr('data-playerId'));


        $('input[type=submit]', modal).attr(
            'data-confirmText', 
            linkElement.attr('data-confirmationText') + playerName + "?"
        );


        modal.modal(); 
    }

    let getPlayerName = (linkElement) => {

        let playerName = ' ' + linkElement.attr('data-playerName');
        
        if(playerName.trim() == '---') {
            playerName = '';
        }

        return playerName;

    }

}

let setupAddIndividualBillingInfoModal = () => {

    $('a.paymentIdLink').click((e) => {
        $('#paymentIdHiddenInput').val($(e.target).attr('data-paymentId'));
    });

}



function showPlayersLicencesModal() 
{
    showModalByName('showPlayersLicencesModal');
}
function showPlayersVersionsModal() 
{
    showModalByName('showPlayersChangeVersionModal');
}
function showPlayersUpdatesModal()
{
    showModalByName('showPlayersUpdatesModal');
}

function showModalByName(name) {
    $('a.' + name).click(function(e) {
        $($(this).attr('data-target')).modal('show');
        $('.spinner', $(this).attr('data-target')).removeClass('display-none');
        $('.modal-body', $(this).attr('data-target')).hide();
    });
}

function showModalsByName() {
    $('a.open-modal-link').click(function(e) {
        $($(this).attr('data-target')).modal('show');
        $('.spinner', $(this).attr('data-target')).removeClass('display-none');
        $('.modal-body', $(this).attr('data-target')).hide();
    });
}

function showCollapsesByName() {
    $('a.open-collapse-link').click(function(e) {
        $($(this).attr('data-target')).collapse('show');
        $('.spinner', $(this).attr('data-target')).removeClass('display-none');
        $('.collapse-body', $(this).attr('data-target')).hide();
    });
}


function showCreateInvoiceModal() 
{
    $('a.showCreateInvoiceModal').click(function(e) {
        var modal = $($(this).attr('data-target'));
        modal.modal('show');
        $('.spinner', $(this).attr('data-target')).removeClass('display-none');
        $('.modal-body', $(this).attr('data-target')).hide();

        $(document).on('submit', 'form.invoiceForPlayerForm', function() {
            setTimeout(function() {
                modal.modal('hide');
                window.location.reload();
            }, 2000);
        });

    });

}

function showEditInModal()
{
    $('a.showEditInModal').click(function(e) {
        $($(this).attr('data-target')).modal('show');
        $('.spinner', $(this).attr('data-target')).removeClass('display-none');
        $('form', $(this).attr('data-target')).hide();
    });
}

function showElasticStatusModal()
{
    $('a.showElasticStatusModal').click(function(e) {
        $($(this).attr('data-target')).modal('show');
        $('.spinner', $(this).attr('data-target')).removeClass('display-none');
    });
}

function showModalOnLoad(){
    var modal = $('#create-schoolAcc');
    if (modal.length > 0) {
        $('#create-schoolAcc').modal({
            backdrop: 'static',
            keyboard: false
        });
        $('.footer').addClass("display-none");
    }
};

function schoolAccModal() {

    if ($('.schoolAcc-nextStep').length == 0) return;

    const inputValidation = new InputValidation("frm-CompanySignupForm-form");

    $('#frm-CompanySignupForm-form').on('keypress', (e) => {
        if (e.which == 13 && $('.schoolAcc-nextStep:visible').length > 0) 
        { 
            $('.schoolAcc-nextStep:visible').click();
            e.preventDefault();
        }
    })
    
    $('input[type=text]', '#frm-CompanySignupForm-form').first().focus();

    $('.schoolAcc-nextStep').click(function() {

        const actualStepNumber = parseInt($(this).attr('data-stepNumber'));
        
        const nextStep = $(this).attr('data-nextStep') !== undefined ?
                             parseInt($(this).attr('data-nextStep')) :
                             actualStepNumber + 1;
                             
        const nextStepEl = $(`.schoolAcc-step${nextStep}`)

        if(inputValidation.errors.length > 0) { return; }

        $(`.schoolAcc-step${actualStepNumber}`).addClass('hidden');
        nextStepEl.removeClass('hidden');

        $('input', nextStepEl).first().focus();

    });
};

function setupOnExitModal() {

    var modal = $('#on-exit-modal');


    if(modal.length > 0) {

        var isMobile = window.matchMedia("only screen and (max-width: 992px)").matches;

        if(!isMobile) {


            $("html").bind("mouseleave", function () {
                
                var loginFormDisplayed = $('.modal-login').hasClass('in') || $('.modal-register').hasClass('in');
                var displayExitPopup = !(modal.hasClass('in')) && !loginFormDisplayed && getCookie('disableExitPopup') != 1;

                if(displayExitPopup) {
                    showModal();
                    $("html").unbind("mouseleave");
                }
            });
            

        } else {
            setTimeout(function(){
                showModal();
            }, 60000);
        }
    }

    $('.exit-popup-register').click(function() {
        
        sendGA('signup', 'standard', 'Signup standard, popup ' + modal.attr('data-module'));        

    });

    $('.exit-popup-register-institution').click(function() {

        var appModule = modal.attr('data-module');

        if(appModule == 'schools') {
            var action = 'school';
        } else {
            var action = 'company';
        }

        sendGA('signup', action, 'Signup ' + action + ' started, popup ' + appModule);        
    })

    $('.logout-button').click(function() {
        setCookie('disableExitPopup', 1, (3600 * 24) * 30);
    })

    modal.on('hidden.bs.modal', function () {
        setCookie('disableExitPopup', 1, 3600);
    })

    
    var showModal = function() {

        $('.modal').not('#on-exit-modal').modal('hide');
        modal.modal();

        sendGA('popup', 'on exit ' + modal.attr('data-module'), 'Exit popup shown')

    }

    var sendGA = function(category, action, label) {

        if (isGaSet) {
            ga('send', 'event', category, action, label);
        }
    }
}

function setupPlayerNotificationModal() {
 
    $(".playerNotificationModal-accept").click(function() {
        var currentDate = Date.now();

        var d = new Date();
        d.setHours(24,0,0,0);
        var nextMidnight = d.getTime();
    
        var secondsToNextMidnight = (Math.abs(currentDate - nextMidnight)) / 1000;
    
        setCookie("showPlayerNotificationModal", 0, secondsToNextMidnight);
    });

    modal = $("#playerNotificationPopup");
    if(getCookie("showPlayerNotificationModal") != 0 || getCookie("showPlayerNotificationModal") == null) {
        modal.modal();
    }
}